var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdAddSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-square-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 2.66666C5.05709 2.66666 2.66927 5.05448 2.66927 8C2.66927 10.9455 5.05709 13.3333 8.0026 13.3333C10.9481 13.3333 13.3359 10.9455 13.3359 8C13.3359 5.05448 10.9481 2.66666 8.0026 2.66666ZM1.33594 8C1.33594 4.3181 4.32071 1.33333 8.0026 1.33333C11.6845 1.33333 14.6693 4.3181 14.6693 8C14.6693 11.6819 11.6845 14.6667 8.0026 14.6667C4.32071 14.6667 1.33594 11.6819 1.33594 8ZM8.0026 4.33333C8.3708 4.33333 8.66927 4.63181 8.66927 4.99999L8.66927 7.33333H11.0026C11.3708 7.33333 11.6693 7.6318 11.6693 8C11.6693 8.36819 11.3708 8.66666 11.0026 8.66666H8.66927V11C8.66927 11.3682 8.37079 11.6667 8.0026 11.6667C7.63441 11.6667 7.33594 11.3682 7.33594 11V8.66666H5.0026C4.63441 8.66666 4.33594 8.36819 4.33594 8C4.33594 7.6318 4.63441 7.33333 5.0026 7.33333H7.33594L7.33594 4.99999C7.33594 4.6318 7.63442 4.33333 8.0026 4.33333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdAddSquare);
export default __webpack_public_path__ + "static/media/id-add-square.f010102fb1da3602d690a160a4eeebb6.svg";
export { ForwardRef as ReactComponent };